// extracted by mini-css-extract-plugin
export default {"container":"enterprise_snippet-module__container--2LQTG"};